import { render } from "./MyDropdown.vue?vue&type=template&id=ceb05660"
import script from "./MyDropdown.vue?vue&type=script&lang=js"
export * from "./MyDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__